// @ts-nocheck
// @ts-ignore
class LazyVideo extends HTMLElement {
    constructor() {
      super();
  
      this._observer = null;
      this._videos = [];
      this._loaded = new WeakSet();
    }
  
    connectedCallback() {
      this._videos = Array.from(this.querySelectorAll('video'));
  
      if (!this._videos.length) return;
  
      this.setupVideos();
      this.createObserver();
      this._onResize = this.handleResize.bind(this);
      window.addEventListener('resize', this._onResize);
    }
  
    disconnectedCallback() {
      this._observer?.disconnect();
      window.removeEventListener('resize', this._onResize);
    }
  
    setupVideos() {
      this._videos.forEach(video => {
        video.preload = 'none';
  
        const source = video.querySelector('source');
  
        // Ensure no eager loading
        if (source?.src) {
          source.removeAttribute('src');
        }
      });
    }
  
    safePlay(video) {
      // Already playing → do nothing
      if (!video.paused) return;
  
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // Ignore AbortError silently
        });
      }
    }
  
    safePause(video) {
      // Already paused → do nothing
      if (video.paused) return;
      video.pause();
    }
  
    handleResize() {
      this._videos.forEach(video => {
        if (!this.shouldLoad(video)) return;
  
        if (!this._loaded.has(video)) {
          this.loadVideo(video);
        }
      });
    }
  
    createObserver() {
      this._observer = new IntersectionObserver(
        this.handleIntersection.bind(this),
        {
          rootMargin: '200px',
          threshold: 0.1,
        }
      );
  
      this._observer.observe(this);
    }
  
    handleIntersection(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this._videos.forEach(video => {
            if (!this.shouldLoad(video)) return;
  
            this.loadVideo(video);
  
            if (video.hasAttribute('autoplay')) {
              this.safePlay(video);
            }
          });
        } else {
          this._videos.forEach(video => {
            if (video.hasAttribute('autoplay')) {
              this.safePause(video);
            }
          });
        }
      });
    }
  
    shouldLoad(video) {
      const minAttr = video.getAttribute('min-width');
      const maxAttr = video.getAttribute('max-width');
  
      const hasMin = minAttr !== null;
      const hasMax = maxAttr !== null;
  
      const width = window.innerWidthCached ?? window.innerWidth;
  
      if (!hasMin && !hasMax) return true;
  
      const min = parseInt(minAttr, 10);
      const max = parseInt(maxAttr, 10);
  
      if (hasMin && !isNaN(min) && width < min) return false;
      if (hasMax && !isNaN(max) && width > max) return false;
  
      return true;
    }
  
    loadVideo(video) {
      if (this._loaded.has(video)) return;
  
      const source = video.querySelector('source');
      const src = source?.dataset?.src;
  
      if (!src) return;
  
      source.src = src;
      video.load();
  
      this._loaded.add(video);
    }
  }
  
  if (!customElements.get('lazy-video')) {
    customElements.define('lazy-video', LazyVideo);
  }